import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  mainFilterLoading: false,
};

const nfms = createSlice({
  name: 'nfms',
  initialState,
  reducers: {
    setMainFilterLoading(state, action: PayloadAction<boolean>) {
      state.mainFilterLoading = action.payload;
    },
  }
});

export const { setMainFilterLoading } = nfms.actions;
export default nfms.reducer;
